<div class="book-container">
  <img src="./../../assets/book/logo_blanc.png" alt="logo" />
  <h1>Mieux comprendre l'amélioration énergétique</h1>
  <button [routerLink]="['/book/part0', caseId]">C'est parti !</button>
  <!-- <app-fullscreen></app-fullscreen> -->
</div>